import axios from "axios";
import api from "../config/api";
import { toast } from "react-toastify";

// Add a response interceptor
axios.interceptors.response.use(null, error => {

  // Check for expected error status codes (400-499) once
  const isExpectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  // Show toast only for unexpected errors
  if (!isExpectedError) {
    toast.error("An unexpected error occured!", error);
  }

  return Promise.reject(error);
});
//authentication
export const signupUser = (verifyEmail, payload) =>
  axios.post(api.authentication.register(verifyEmail), payload);
export const signinUser = (payload) =>
  axios.post(api.authentication.login, payload);
export const generateOTP = (payload) =>
  axios.post(api.authentication.generateOTP, payload);
export const verifyUser = (payload) =>
  axios.post(api.authentication.verifyUser, payload);
export const resendOTP = (payload) =>
  axios.post(api.authentication.resendOTP, payload);
export const resetPassword = (payload) =>
  axios.patch(api.authentication.resetPassword, payload);
// Bare instance — deliberately NOT the shared `axios` default.
//
// Two global response interceptors sit on the default instance (the one above,
// and transportInterceptors.js) and both toast on a non-401 failure. The P2P
// SSO mint is the one call that MUST fail silently: it always has a fallback
// (an anonymous redirect to P2P), so a failed mint is a downgrade, not an
// error the user should be shouted at about. Interceptors registered on the
// default instance do not apply to one built with axios.create().
const p2pSsoClient = axios.create();

export const getP2pSsoToken = (config) =>
  p2pSsoClient.get(api.authentication.p2pSsoToken, config);

//Website landing page APIs
// export let websiteStats = axios.get(api.website.stats);
//user-details
// export const userStatus = (id, payload) => axios.post(api.userDetails.userStatus(id), payload);
export const userPersonalDetails = (id, payload, config) =>
  axios.put(api.userDetails.userPersonalDetails(id), payload, config);
export const getUserPersonalDetails = (id, config) =>
  axios.get(api.userDetails.userPersonalDetails(id), config);

// Jury vote pre-flight. Ask the backend (which asks the chain) whether this
// juror may vote, BEFORE sending an irreversible on-chain vote.
export const checkVoteEligibility = (transactionId, config) =>
  axios.get(api.panel.voteEligibility(transactionId), config);

// Dispute/appeal fee pre-flight. Ask the backend (which asks the chain)
// whether this account may be charged, BEFORE offering the fee screen. On the
// appeal path the router has no re-entry guard, so getting this wrong takes a
// second 10 DAI with nothing on-chain to stop it.
export const getStageState = (transactionId, config) =>
  axios.get(api.panel.stageState(transactionId), config);

// REST twin of the disputeOpenedOnChain / appealOpenedOnChain socket events.
export const postStageOpenedOnChain = (payload, config) =>
  axios.post(api.panel.stageOpenedOnChain, payload, config);

// Jury stake (synced from Polygon -> persisted in backend MongoDB)
export const getJuryStake = (refresh = true, config) =>
  axios.get(`${api.userDetails.juryStake}?refresh=${refresh}`, config);

// Unstake — paid by the backend; `unlockStake` is admin-only on the router.
export const unlockJuryStake = (payload, config) =>
  axios.post(api.userDetails.unlockJuryStake, payload, config);

export const userBankDetails = (payload, config) =>
  axios.post(api.userDetails.userBankDetails, payload, config);
export const deleteBank = (bankId, config) =>
  axios.delete(api.panel.deleteBank(bankId), config)
export const updateUser = (id, payload, config) =>
  axios.put(api.userDetails.updateUser(id), payload, config);
export const addCollateral = (payload, config) =>
  axios.post(api.userDetails.addCollateral, payload, config);
export const removeCollateral = (payload, config) =>
  axios.post(api.userDetails.removeCollateral, payload, config);
export const getUserBalance = (config) =>
  axios.get(api.userDetails.getUserBalance, config);

//get-transactions-panel
export const getTransactions = (
  filter,
  pageSize,
  pageNumber,
  custodianLiveOrders,
  config
) => {

  return axios.get(
    api.panel.getTransactions(
      filter,
      pageSize,
      pageNumber,
      custodianLiveOrders
    ),
    config
  );
};

export const getUserBatchEarning = (config, filter,
  pageSize,
  pageNumber) =>
  axios.get(api.panel.userBatchEarning(filter,
    pageSize,
    pageNumber), config);
export const getTransactionsJuryOrdersLive = (config) =>
  axios.get(api.panel.getTransactionsJuryOrdersLive, config);

//panel-dashbaord
export const getAllOrders = (region, config) =>
  axios.get(api.panel.allOrders(region), config);
export const orders = (showDepositOrders, region, config) =>
  axios.get(api.panel.orders(showDepositOrders, region), config);
export const ordersHistory = (userId, time, isCustodian, config) =>
  axios.get(api.panel.ordersHistory(userId, time, isCustodian), config);

export const getCustodianLimits = (config) =>
  axios.get(api.panel.getCustodianLimits, config);
export const getCustodianLimitsFromDb = (config) =>
  axios.get(api.panel.getCustodianLimitsFromDb, config);
export const editAvailability = (payload, config) =>
  axios.put(api.panel.editAvailability, payload, config);

export const claimEarning = (payload, config) =>
  axios.put(api.panel.claimEarning, payload, config);

export const claimTirbEarning = (payload, config) =>
  axios.put(api.panel.claimTribEarning, payload, config);

export const getPendingEarnings = (role, config) =>
  axios.get(api.panel.getPendingEarnings(role), config)

//panel-order
export const orderStatus = (payload, config) =>
  axios.put(api.panel.orderStatus, payload, config);
export const successTransaction = (payload, config) =>
  axios.put(api.panel.successTransaction, payload, config);
export const cancelOrder = (payload, config) =>
  axios.put(api.panel.cancelOrder, payload, config);
export const transactionApproval = (payload, config) =>
  axios.put(api.panel.approveTransaction, payload, config);
export const getTransactionById = (transactionId, config) =>
  axios.get(api.panel.getTransactionByTransactionId(transactionId), config);
export const uploadVideo = (payload, config) =>
  axios.put(api.panel.uploadVideo, payload, config);
export const getUserRewards = (config) =>
  axios.get(api.panel.getRewards, config);

//panel-settings
export const updateUserPersonalDetails = (userId, payload, config) =>
  axios.put(api.panel.settings.updatePersonalInfo(userId), payload, config);
export const changePassword = (payload, config) =>
  axios.patch(api.panel.changePassword, payload, config);
export const userBanks = (userId, config) =>
  axios.get(api.panel.banks(userId), config);
export const createRegion = (userId, regionName, payload, config) =>
  axios.post(
    api.panel.settings.createRegion(userId, regionName),
    payload,
    config
  );
export const addRegionBank = (regionId, payload, config) =>
  axios.post(api.panel.settings.addRegionBank(regionId), payload, config);
export const selectedBank = (userId, regionId, bankId, config) =>
  axios.put(api.panel.selectBank(userId, regionId, bankId), "", config);
export const changeLoginEmailOrNumber = (payload, config) =>
  axios.put(api.panel.settings.changeLoginEmailOrNumber, payload, config);
export const updateProfilePicture = (payload, config) =>
  axios.put(api.panel.updateProfilePicture, payload, config);
export const makeDefaultBanks = (userId, bankId, payload, config) =>
  axios.put(
    api.panel.settings.makeDefaultBank(userId, bankId),
    payload,
    config
  );

//panel-create-order
export const createOrder = (payload, config) =>
  axios.post(api.panel.createOrder, payload, config);

//web3
export const depositOPNs = (payload, config) =>
  axios.put(api.panel.opns.depositOpns, payload, config);

//wallet
export const userWalletDetails = (userId, config) =>
  axios.get(api.panel.wallet(userId), config);

//chat
export const getChat = (userId, custodianId, transactionId, config) =>
  axios.get(api.panel.chat.getChat(userId, custodianId, transactionId), config);

// Authenticated: the server decides from the caller who may read the chat
// (midl-server ROUTER-DISPUTE-DRAIN-FIX-PLAN §14). Callers pass no config, and
// `config` used to be handed to the URL builder, so no header was ever sent.
export const getChatFromTxId = (txId, userId, config) =>
  axios.get(
    api.panel.chat.getChatFromTxId(txId, userId),
    config ?? {
      headers: { Authorization: `Bearer ${localStorage.getItem("Token")}` },
    }
  );

export const updateChatReadStatus = (payload, config) =>
  axios.patch(api.panel.chat.updateChatReadStatus, payload, config);

export const createChatRoom = (payload, config) =>
  axios.post(api.panel.chat.createChatRoom, payload, config);
export const sendMessage = (payload, config) =>
  axios.post(api.panel.chat.sendMessage, payload, config);

//ticker
export const ticker = (config) => axios.get(api.ticker.getAllTickers, config);
export const getAllTokens = (config) => axios.get(api.currencies.getAllCurrencies, config);

//jury-dashboard
export const getDisputedOrders = (showDepositOnly, region, config) =>
  axios.get(api.panel.disputeOrders(showDepositOnly, region), config);
export const giveVote = (payload, config) =>
  axios.put(api.panel.voteOrder, payload, config);
export const juryHistory = (time, filter, pageSize, pageNumber, config) =>
  axios.get(api.panel.juryHistory(time, filter, pageSize, pageNumber), config);

//role-switch
export const updateUserRole = (id, payload, config) =>
  axios.put(api.switchRole.updateRole(id), payload, config);

//jury-request-proof
export const getRequestedProof = (transactionId, config) =>
  axios.get(api.panel.juryProof.getRequestedProof(transactionId), config);
export const requestProof = (payload, config) =>
  axios.post(api.panel.juryProof.requestProof, payload, config);
export const submitProof = (payload, config) =>
  axios.post(api.panel.juryProof.submitProof, payload, config);

//open-dispute
export const openOrderDispute = (payload, config) =>
  axios.put(api.panel.openDispute, payload, config);
export const openOrderAppeal = (payload, config) =>
  axios.put(api.panel.openAppeal, payload, config);

//vote-appeal-order
export const voteAppealOrder = (payload, config) =>
  axios.put(api.panel.voteAppealOrder, payload, config);

//appeal-transactions-tribunal
export const getApplealedTransactions = (pageSize, pageNumber, config) =>
  axios.get(api.panel.tribunalAppealedTransactions(pageSize, pageNumber), config);
export const getApplealedCompleteTransactions = (filter, pageSize, pageNumber, config) =>
  axios.get(api.panel.tribunalCompleteTransactions(filter, pageSize, pageNumber), config);

//custodian-portfolio
export const getCustodianProtfolio = (config) =>
  axios.get(api.panel.custodianPortfolio, config);

//custodian-dashboard
export const getCustodianDashboardData = (config) =>
  axios.get(api.panel.custodianDashboardData, config);

//user-portfoliio
export const userPortfolio = (config) =>
  axios.get(api.panel.userPortfolio, config);

//close-dispute-after-jury-vote
export const closeDisputeAfterJuryVotes = (transactionId, payload, config) =>
  axios.put(
    api.panel.closeDisputeAfterJuryVotes(transactionId),
    payload,
    config
  );

//add-proof-for-dispute-or-appeal
export const uploadProofForDisputeOrAppeal = (payload, config) =>
  axios.put(api.panel.addProofForDisputeOrAppeal, payload, config);

//user-batch-portfolio-dashboard
export const userBatchPortfolioData = (config) =>
  axios.get(api.panel.userBatchPortfolioData, config);

//user-total-transfer-dashboard
export const userTotalTransfer = (config) =>
  axios.get(api.panel.userTotalTransferDta, config);

//cust-total-batches-dashboard
export const custTotalBatches = (config) =>
  axios.get(api.panel.custTotalBatches, config);

//set-txId
export const setOrderTxId = (transactionId, txId, config) =>
  axios.put(api.panel.sendTxId(transactionId, txId), {}, config);

//custodian-dashboard-pool-earning
export const getCustodianPoolAmount = (config) =>
  axios.get(api.panel.getCustodianPoolAmount, config);

//custodian-ramp-value
export const getRampValue = (config) =>
  axios.get(api.panel.getRampValue, config);

//get-custodian-earnings
export const getCustEarnings = (earning, config) =>
  axios.get(api.panel.getEarning(earning), config);

//claim-available-reward
export const claimAvailableRewards = (currency, amount, config) =>
  axios.get(api.panel.claimAvailableReward(currency, amount), config);

//claim-pool-reward
export const claimPoolRewards = (currency, amount, config) =>
  axios.get(api.panel.claimPoolReward(currency, amount), config);

//jury-stake-page
export const stakingActions = (payload, config) =>
  axios.post(api.panel.stakingActions, payload, config);
export const getAllStaking = (pageSize, pageNumber, config) => axios.get(api.panel.getAllStaking(pageSize, pageNumber), config);

//claim-jury-reward-pool
export const claimJuryRewardPool = (amount, currency, config) =>
  axios.put(api.panel.claimJuryRewardPool(amount, currency), {}, config);

//claim-custodian-reward-pool
export const claimCustodianRewardPool = (amount, currency, config) =>
  axios.put(api.panel.claimCustodianRewardPool(amount, currency), {}, config);

//claim-ramp--pool
export const claimRampAmount = (amount, currency, config) =>
  axios.get(api.panel.claimRampAmount(amount, currency), config);

//referral
export const getReferralMe = (config) =>
  axios.get(api.panel.referral.me, config);
export const getReferralSummary = (config) =>
  axios.get(api.panel.referral.summary, config);
export const getReferralHistory = (pageSize, pageNumber, config) =>
  axios.get(api.panel.referral.history(pageSize, pageNumber), config);
export const validateReferralCode = (code, config) =>
  axios.get(api.panel.referral.validate(code), config);

export const getAllCountries = () => axios.get(api.countries.getAllCountries())

export const getStatesOfCountry = (countryCode) => axios.get(api.countries.getStatesOfCountry(countryCode))

export const getCitiesOfCountry = (countryCode, isoCode) => axios.get(api.countries.getCitiesOfCountry(countryCode, isoCode))